import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-3" }
const _hoisted_2 = { class: "flex flex-col mb-3" }
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = {
  ref: "empty",
  class: "h-0 w-0 outline-none"
}
const _hoisted_5 = { class: "hidden lg:table border-collapse border w-full table-auto relative" }
const _hoisted_6 = {
  class: "sticky bg-white border border-next-light-gray z-10",
  style: {"top":"calc(var(--top-navigation-height))"}
}
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  key: 0,
  class: "border bg-next-bri whitespace-nowrap"
}
const _hoisted_9 = {
  key: 1,
  colspan: "3",
  class: "border bg-next-pro"
}
const _hoisted_10 = {
  key: 2,
  class: "border"
}
const _hoisted_11 = {
  key: 3,
  class: "border"
}
const _hoisted_12 = { class: "border" }
const _hoisted_13 = { class: "relative flex items-stretch" }
const _hoisted_14 = ["value", "onChange"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "border w-20" }
const _hoisted_17 = {
  colspan: "4",
  class: "border relative"
}
const _hoisted_18 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_19 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_20 = {
  key: 0,
  class: "text-sm flex flex-col"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm flex flex-col"
}
const _hoisted_22 = {
  class: "sticky bg-white border border-next-light-gray z-10",
  style: {"bottom":"0"}
}
const _hoisted_23 = { class: "border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Star = _resolveComponent("Star")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
        backdrop: true
      }, {
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Field, { field_name: "Descrizione" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  class: "border mb-3 border-next-dark-gray",
                  rows: "3",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.note) = $event))
                }, "                        ", 512), [
                  [_vModelText, _ctx.note]
                ])
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Field, { field_name: "Attività" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  options: _ctx.attivitaTimesheetAutocomplete.options,
                  modelValue: _ctx.attivitaTimesheetAutocomplete.selection,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.attivitaTimesheetAutocomplete.selection) = $event)),
                  loading: _ctx.attivitaTimesheetAutocomplete.isLoading,
                  onSearchChange: _ctx.attivitaTimesheetAutocomplete.search,
                  class: "mb-3 next-vue-multiselect-single",
                  "close-on-select": true,
                  "clear-on-select": false,
                  label: "descrizione",
                  "track-by": "id",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona"
                }, null, 8, ["options", "modelValue", "loading", "onSearchChange"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, !_ctx.currentEditingIsAttivita]
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_NextButton, {
              onClick: _ctx.close,
              variant: "outline-secondary",
              class: "w-44 py-1 px-2 mr-2"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Chiudi ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NextButton, {
              onClick: _ctx.addDescription,
              variant: "outline-primary",
              class: "w-44 py-1 px-2"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Salva ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createElementVNode("input", _hoisted_4, null, 512),
    _createElementVNode("table", _hoisted_5, [
      _createElementVNode("thead", _hoisted_6, [
        _createElementVNode("tr", null, [
          _cache[11] || (_cache[11] = _createElementVNode("th", null, null, -1)),
          _cache[12] || (_cache[12] = _createElementVNode("th", { class: "border" }, "Sottoprogetto", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("th", { class: "border" }, "Titolo", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("th", { class: "border" }, "Cliente", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WeekDays, (d, i) => {
            return (_openBlock(), _createElementBlock("th", {
              class: "border w-20",
              key: i
            }, _toDisplayString(d.format('dd D')), 1))
          }), 128)),
          _cache[15] || (_cache[15] = _createElementVNode("th", { class: "border" }, "Totale progetto", -1))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (r, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: r.id,
            class: _normalizeClass({'hidden': r.hidden})
          }, [
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_Star, {
                class: "text-yellow-500",
                starred: r.starredByUser,
                onClick: ($event: any) => (_ctx.handleStar(r, _ctx.isRecordAttivita(i)))
              }, null, 8, ["starred", "onClick"])
            ]),
            (_ctx.isRecordSottoprogetto(i))
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(r.cod_nodo), 1))
              : _createCommentVNode("", true),
            (_ctx.isRecordAttivita(i))
              ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(r.descrizione), 1))
              : _createCommentVNode("", true),
            (_ctx.isRecordSottoprogetto(i))
              ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(r.titolo), 1))
              : _createCommentVNode("", true),
            (_ctx.isRecordSottoprogetto(i))
              ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(r.committente_denominazione), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WeekDays, (d, j) => {
              return (_openBlock(), _createElementBlock("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "w-20 bg-transparent focus:bg-white",
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.focusOut && _ctx.focusOut(...args)), ["esc"])),
                    value: _ctx.getInputValue(i,j),
                    onChange: ($event: any) => (_ctx.onChangeTime($event,i,j)),
                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validateInput && _ctx.validateInput(...args)))
                  }, null, 40, _hoisted_14),
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon-info absolute right-0 cursor-pointer self-center", {'text-next-orange': _ctx.hasExtraData(i,j)}]),
                    onClick: ($event: any) => (_ctx.openModal(i,j))
                  }, null, 10, _hoisted_15)
                ])
              ]))
            }), 256)),
            _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.timeToFormat(_ctx.TotaleProgetto(i))), 1)
          ], 2))
        }), 128)),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_17, [
            _withDirectives(_createElementVNode("div", {
              class: "w-full",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openAutocomplete && _ctx.openAutocomplete(...args)))
            }, " Aggiungi attività ", 512), [
              [_vShow, !_ctx.showAutocomplete]
            ]),
            _withDirectives(_createVNode(_component_VueMultiselect, {
              ref: "select",
              onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.$refs.select.deactivate()), ["esc"])),
              onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAutocomplete = false)),
              "internal-search": false,
              "close-on-select": true,
              "clear-on-select": true,
              class: "next-vue-multiselect-single",
              placeholder: "Sottoprogetto/Attività",
              deselectLabel: "Deseleziona",
              selectedLabel: "Selezionato",
              selectLabel: "Seleziona",
              "track-by": "id",
              options: _ctx.sottoprogetto_attivita_options,
              onSearchChange: _ctx.onSearchSottoprogettoAttivita,
              modelValue: _ctx.sottoprogetto_attivita_selection,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sottoprogetto_attivita_selection) = $event))
            }, {
              singleLabel: _withCtx(({option}) => [
                (_ctx.isSottoprogetto(option))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(option.cod_nodo), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(option.descrizione), 1))
              ]),
              option: _withCtx(({option}) => [
                (_ctx.isSottoprogetto(option))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createElementVNode("span", null, "Cod: " + _toDisplayString(option.cod_nodo), 1),
                      _createElementVNode("span", null, "BU: " + _toDisplayString(option.bu_label), 1),
                      _createElementVNode("span", null, "Titolo: " + _toDisplayString(option.titolo), 1),
                      _createElementVNode("span", null, "Cliente: " + _toDisplayString(option.committente_denominazione), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _createElementVNode("span", null, "Attività: " + _toDisplayString(option.descrizione), 1)
                    ]))
              ]),
              _: 1
            }, 8, ["options", "onSearchChange", "modelValue"]), [
              [_vShow, _ctx.showAutocomplete]
            ])
          ])
        ])
      ]),
      _createElementVNode("tfoot", _hoisted_22, [
        _createElementVNode("tr", null, [
          _cache[16] || (_cache[16] = _createElementVNode("th", {
            class: "border",
            colspan: "4"
          }, "Totale attività", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WeekDays, (d, i) => {
            return (_openBlock(), _createElementBlock("th", _hoisted_23, _toDisplayString(_ctx.timeToFormat(_ctx.TotaleGiorno(i))), 1))
          }), 256)),
          _cache[17] || (_cache[17] = _createElementVNode("th", { class: "border" }, null, -1))
        ])
      ])
    ])
  ]))
}